export const monthMarkers = (startMonthElements: Node[], REM: number) =>
  Array.from(startMonthElements).map((item) => (item as HTMLElement).offsetLeft / REM);
